import { render, staticRenderFns } from "./CodeModal.vue?vue&type=template&id=5baf19db&"
import script from "./CodeModal.vue?vue&type=script&lang=ts&"
export * from "./CodeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports